import { handleRequest } from "../utilities/requestHandler";

export const updatePassword = (req_body) =>
    handleRequest("post","users/updatepassword",req_body);